// extracted by mini-css-extract-plugin
module.exports = {"count":"SupportersList_count__HoeGO","placeholderBar":"SupportersList_placeholderBar__SvSMp","error":"SupportersList_error__0aXz2"};